import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  public userName: string = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Load username from localStorage if available
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' && window.localStorage) {
      this.userName = localStorage.getItem('username') || '';
    }
  }

  setUserName(username: string): void {
    this.userName = username;
    // Persist username in localStorage
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('username', username);
    }
  }

  clearUser(): void {
    this.userName = '';
    // Clear username from localStorage
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem('username');
    }
  }
}
